export default "__VITE_ASSET__lolnq5j2__"